/* Order Trailer Parts - Brian James parts finder
   Renders one model's finder from the payload in window.BJT_FINDER_DATA,
   then overlays live price, stock and description from the storefront
   products.json so the tables follow the catalogue instead of going stale.

   Description falls back to Brian James' own catalogue text, carried in the
   payload, for part numbers we do not list as products. */
(function(){
  function init(root){
    var cfgEl = root.querySelector('[data-bjtf-config]');
    if (!cfgEl || root.dataset.bjtfReady) return;
    root.dataset.bjtfReady = '1';
    var CFG = JSON.parse(cfgEl.textContent);

    var elIndex = root.querySelector('[data-bjtf-index]');
    var elOverlay = root.querySelector('[data-bjtf-overlay]');
    var elBuildRow = root.querySelector('[data-bjtf-buildrow]');
    var elBuild = root.querySelector('[data-bjtf-build]');
    var lb = root.querySelector('[data-bjtf-lb]');
    var lbImg = root.querySelector('[data-bjtf-lbimg]');
    var lbPos = root.querySelector('[data-bjtf-lbpos]');
    var lbNo = root.querySelector('[data-bjtf-lbno]');
    var DATA = null, LIVE = null, CURRENT = null, lastThumb = null;

    function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'})[c]; }); }
    function money(v){ var n = Number(v); if (!isFinite(n)) return '';
      return '$' + n.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); }
    function handleOf(b){ return 'bjt-' + String(b).toLowerCase(); }

    /* Product titles open with the brand, which is already all over the page. */
    function trimBrand(t){ return String(t || '').replace(/^Brian James\s+/i, '').trim(); }
    function shortDesc(t){
      var s = trimBrand(t);
      if (s.length <= 95) return s;
      var cut = s.slice(0, 95);
      var sp = cut.lastIndexOf(' ');
      if (sp > 55) cut = cut.slice(0, sp);
      return cut + '…';
    }

    function resolve(r){
      var bjt = r.bjt || null, sku = r.sku || null, price = r.price || null;
      if (r.col && CURRENT && DATA.builds[CURRENT]) {
        bjt = (DATA.builds[CURRENT].c || {})[r.col] || null;
        var hit = bjt && DATA.cat ? DATA.cat[bjt] : null;
        sku = hit ? hit[0] : null;
        price = hit ? hit[1] : null;
      }
      var live = (bjt && LIVE) ? (LIVE[handleOf(bjt)] || null) : null;
      if (live) { price = live.price; sku = sku || ('OTP-' + bjt); }
      return { pos: r.pos, note: r.note, bjt: bjt, sku: sku, price: price,
               title: live ? live.title : null,
               available: live ? live.available : null, listed: !!live };
    }

    function rowHtml(r){
      var num = r.bjt
        ? (r.listed ? '<a href="' + esc(CFG.shop + String(r.bjt).toLowerCase()) + '">' + esc(r.bjt) + '</a>' : esc(r.bjt))
        : '—';
      /* Our product title first; Brian James' catalogue text where we have no product. */
      var dsrc = r.title || (r.bjt && DATA.descs ? DATA.descs[r.bjt] : '') || '';
      var desc = dsrc
        ? '<span title="' + esc(trimBrand(dsrc)) + '">' + esc(shortDesc(dsrc)) + '</span>'
        : '<span class="none">—</span>';
      var stock = r.available === true
        ? '<span class="bjtf-chip yes">In stock</span>'
        : (r.listed ? '<span class="bjtf-chip no">' + esc(CFG.callText) + '</span>'
                    : '<span class="bjtf-chip no">Not stocked yet</span>');
      var pic = '';
      if (r.bjt && DATA.pics && DATA.pics.indexOf(r.bjt) !== -1) {
        var src = CFG.imgBase + String(r.bjt).toLowerCase() + '.jpg';
        pic = '<button type="button" class="bjtf-thumb" data-pic="' + esc(src) + '" data-pos="' +
          esc(r.pos) + '" data-no="' + esc(r.bjt) + '" aria-label="Enlarge photo of ' + esc(r.pos) +
          '"><img src="' + esc(src) + '" alt="' + esc(r.pos) + ', Brian James ' + esc(r.bjt) +
          '" loading="lazy" decoding="async"></button>';
      } else if (r.bjt && (r.listed || r.sku)) {
        /* We carry it but have not photographed it yet. A blank cell reads as
           "we do not have this part", so say what is actually missing. */
        pic = '<span class="bjtf-thumb bjtf-thumb--soon">Photo<br>coming<br>soon</span>';
      }
      return '<tr><td class="pos">' + esc(r.pos) +
        (r.note ? '<span class="sku">' + esc(r.note) + '</span>' : '') + pic +
        '</td><td class="bjtno">' + num + '</td><td class="desc">' + desc + '</td><td>' + stock +
        '</td><td class="money">' + (r.price ? money(r.price) : '<span class="quote">Call for a quote</span>') +
        '</td></tr>';
    }

    function render(){
      if (!DATA) return;
      elIndex.innerHTML = DATA.zones.map(function(z){
        var rows = (z.rows || []).map(resolve);
        var withNo = rows.filter(function(r){ return r.bjt; }).length;
        var count = !rows.length ? 'part numbers coming' : withNo + ' of ' + rows.length + ' identified';
        var body = !rows.length ? '' :
          '<div class="bjtf-zone__body">' +
            (z.lead ? '<p class="bjtf-zone__lead">' + esc(z.lead) + '</p>' : '') +
            '<div class="bjtf-tablewrap"><table class="bjtf-table"><thead><tr>' +
            '<th>Part</th><th>Brian James no.</th><th>Description</th><th>Availability</th><th class="money">Price</th>' +
            '</tr></thead><tbody>' + rows.map(rowHtml).join('') + '</tbody></table></div></div>';
        return '<section class="bjtf-zone" data-z="' + z.n + '">' +
          '<button type="button" aria-expanded="false">' +
            '<span class="bjtf-zone__num' + (z.opt ? ' bjtf-zone__num--opt' : '') + '">' +
              (z.opt ? 'OPT' : z.n) + '</span>' +
            '<span class="bjtf-zone__name">' + esc(z.name) + '</span>' +
            '<span class="bjtf-zone__count">' + esc(count) + '</span>' +
          '</button><div class="bjtf-zone__body-wrap" hidden>' + body + '</div></section>';
      }).join('');
    }

    function selectZone(n, scroll){
      var zones = elIndex.querySelectorAll('.bjtf-zone');
      for (var i = 0; i < zones.length; i++){
        var z = zones[i];
        var on = z.dataset.z === String(n);
        z.classList.toggle('is-on', on);
        var btn = z.querySelector('button');
        var wrap = z.querySelector('.bjtf-zone__body-wrap');
        btn.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (wrap) wrap.hidden = !on;
        if (on && scroll) z.scrollIntoView({behavior:'smooth', block:'start'});
      }
      var marks = elOverlay.querySelectorAll('.marker');
      for (var j = 0; j < marks.length; j++){
        marks[j].classList.toggle('is-on', marks[j].dataset.z === String(n));
      }
    }

    elIndex.addEventListener('click', function(e){
      var thumb = e.target.closest ? e.target.closest('.bjtf-thumb') : null;
      if (thumb && thumb.dataset.pic) { openPic(thumb); return; }
      var btn = e.target.closest ? e.target.closest('.bjtf-zone > button') : null;
      if (!btn) return;
      var z = btn.parentNode;
      var open = btn.getAttribute('aria-expanded') === 'true';
      selectZone(open ? null : z.dataset.z, false);
    });

    function openPic(btn){
      lastThumb = btn;
      lbImg.src = btn.dataset.pic;
      lbImg.alt = btn.dataset.pos + ', Brian James ' + btn.dataset.no;
      lbPos.textContent = btn.dataset.pos;
      lbNo.textContent = btn.dataset.no;
      lb.hidden = false;
      document.body.style.overflow = 'hidden';
      var c = root.querySelector('[data-bjtf-lbclose]'); if (c) c.focus();
    }
    function closePic(){
      lb.hidden = true;
      document.body.style.overflow = '';
      if (lastThumb) lastThumb.focus();
    }
    if (lb) {
      lb.addEventListener('click', function(e){
        if (e.target === lb || (e.target.closest && e.target.closest('[data-bjtf-lbclose]'))) closePic();
      });
      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape' && !lb.hidden) closePic();
      });
    }

    function mountSvg(){
      if (!DATA.svg || !elOverlay) return;
      elOverlay.innerHTML = DATA.svg;
      /* The payload SVG carries its own copy of the drawing as a relative
         <image href="...">. That path does not resolve on the storefront and
         the section already renders the drawing underneath, so drop it. */
      var embedded = elOverlay.querySelectorAll('image');
      for (var e = embedded.length - 1; e >= 0; e--) {
        embedded[e].parentNode.removeChild(embedded[e]);
      }
      var marks = elOverlay.querySelectorAll('.marker');
      for (var i = 0; i < marks.length; i++){
        (function(m){
          m.addEventListener('click', function(){ selectZone(m.dataset.z, true); });
          m.addEventListener('keydown', function(ev){
            if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); selectZone(m.dataset.z, true); }
          });
        })(marks[i]);
      }
    }

    function mountBuilds(){
      var keys = Object.keys(DATA.builds || {});
      if (!keys.length) { elBuildRow.hidden = true; return; }
      elBuildRow.hidden = false;
      elBuild.innerHTML = keys.map(function(k){
        return '<option value="' + esc(k) + '">' + esc(DATA.builds[k].d || k) + '</option>';
      }).join('');
      CURRENT = keys[0];
      elBuild.value = CURRENT;
      elBuild.addEventListener('change', function(){ CURRENT = elBuild.value; render(); });
    }

    function loadLive(){
      return fetch('/collections/' + CFG.collection + '/products.json?limit=250', {headers:{'Accept':'application/json'}})
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(j){
          if (!j || !j.products) return;
          LIVE = {};
          j.products.forEach(function(p){
            var v = (p.variants || [])[0] || {};
            LIVE[p.handle] = { price: v.price, available: !!v.available, title: p.title };
          });
        })
        .catch(function(){});
    }

    function boot(){
      var all = window.BJT_FINDER_DATA || {};
      DATA = all[CFG.slug];
      if (!DATA) {
        elIndex.innerHTML = '<p class="bjtf__loading">The parts list for this model is still being prepared. Call 208-459-8345 and we will look it up for you.</p>';
        return;
      }
      mountSvg();
      mountBuilds();
      render();
      loadLive().then(render);
    }

    var dataScript = root.querySelector('[data-bjtf-data]');
    if (window.BJT_FINDER_DATA && window.BJT_FINDER_DATA[CFG.slug]) boot();
    else if (dataScript) {
      dataScript.addEventListener('load', boot);
      dataScript.addEventListener('error', function(){
        elIndex.innerHTML = '<p class="bjtf__loading">We could not load the parts list just now. Call 208-459-8345 and we will look it up for you.</p>';
      });
    }
  }

  function scan(){
    var all = document.querySelectorAll('[data-bjtf]');
    for (var i = 0; i < all.length; i++) init(all[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
